import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import { FaPlus, FaFolder } from 'react-icons/fa';
import { useToast } from '../contexts/ToastContext';
import { Button } from '../components/ui/button';
import AddProjectModal from '../components/projects/AddProjectModal';
import ProjectCard from '../components/projects/ProjectCard';
// import { useAuth } from '../hooks/useAuth'; // Uncomment if needed

function Projects() {
  const [projects, setProjects] = useState([]);
  const [showAddProjectModal, setShowAddProjectModal] = useState(false);
  // const { user } = useAuth(); // Uncomment if needed
  const addToast = useToast();

  useEffect(() => {
    const fetchProjects = async () => {
      const { data, error } = await supabase
        .from('projects')
        .select('id, name, description, is_favorite, project_groups!inner (id, name), tasks (id, name, description)');

      if (error) {
        console.error('Error fetching projects:', error);
        addToast('Error fetching projects: ' + error.message, 'danger');
      } else {
        // Sort projects: favorited first, then alphabetical
        const sortedData = data.sort((a, b) => {
          if (a.is_favorite === b.is_favorite) {
            return a.name.localeCompare(b.name);
          }
          return b.is_favorite - a.is_favorite;
        });
        setProjects(sortedData);
      }
    };

    fetchProjects();
  }, [addToast]);

  const handleProjectAdded = (newProject) => {
    setProjects((prev) => [...prev, newProject]);
  };

  const handleProjectUpdated = (updatedProject) => {
    setProjects((prev) =>
      prev.map((project) => (project.id === updatedProject.id ? updatedProject : project))
    );
  };

  const handleProjectDeleted = (deletedProjectId) => {
    setProjects((prev) => prev.filter((project) => project.id !== deletedProjectId));
  };

  const handleToggleFavorite = async (projectId, isFavorite) => {
      console.log("Re-sorting projects");
      setProjects((prev) =>
        prev
          .map((project) => (project.id === projectId ? { ...project, is_favorite: !isFavorite } : project))
          .sort((a, b) => {
            if (a.is_favorite === b.is_favorite) {
              return a.name.localeCompare(b.name);
            }
            return b.is_favorite - a.is_favorite;
          })
      );

  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      {/* Header */}
      <div className="flex items-center justify-between mb-8">
        <div className="flex items-center">
          <FaFolder className="w-6 h-6 mr-3 text-red-600" />
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
            Projects
          </h1>
        </div>
        <Button onClick={() => setShowAddProjectModal(true)} className="flex items-center space-x-2">
          <FaPlus className="w-4 h-4" />
          <span>Add Project</span>
        </Button>
      </div>

      {/* Projects Grid */}
      {projects.length === 0 ? (
        <div className="text-center py-12">
          <FaFolder className="w-16 h-16 mx-auto text-gray-300 dark:text-gray-600 mb-4" />
          <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
            No projects yet
          </h3>
          <p className="text-gray-500 dark:text-gray-400 mb-6">
            Create your first project to start organizing your tasks.
          </p>
          <Button onClick={() => setShowAddProjectModal(true)}>
            <FaPlus className="w-4 h-4 mr-2" />
            Create Project
          </Button>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {projects.map((project) => (
            <ProjectCard
              key={project.id}
              project={project}
              onProjectUpdated={handleProjectUpdated}
              onProjectDeleted={handleProjectDeleted}
              onToggleFavorite={handleToggleFavorite}
            />
          ))}
        </div>
      )}
      
      {/* Modal */}
      {showAddProjectModal && (
        <AddProjectModal
          show={showAddProjectModal}
          handleClose={() => setShowAddProjectModal(false)}
          onProjectAdded={handleProjectAdded}
        />
      )}
    </div>
  );
}

export default Projects;